const Style = {

  // ── Layout ─────────────────────────────────────────────────────────────────
  toolbar:          'flex justify-between items-center mb-4',
  tabGroup:         'flex items-center gap-2',
  eventRow:         'mb-4 flex items-center gap-3',
  cohortControls:   'mb-4 flex items-center gap-3 flex-wrap',

  // ── Shared button (tabs + selectors) ───────────────────────────────────────
  btnBase:          'inline-flex items-center gap-1.5 py-1.5 px-3 rounded-lg cursor-pointer text-sm font-medium whitespace-nowrap border transition-colors',
  btnActive:        'border-blue-600 bg-blue-50 text-blue-600',
  btnInactive:      'border-gray-200 bg-white text-gray-700 hover:border-gray-300',

  // ── Date range selector ─────────────────────────────────────────────────────
  dateDropdown:     'absolute right-0 top-[calc(100%+6px)] bg-white border border-gray-200 rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] z-50 w-60 overflow-hidden',
  presetBtn:        'block w-full text-left py-2 px-3.5 border-none text-[13px] text-gray-700 cursor-pointer hover:bg-gray-50 transition-colors',
  presetActive:     'bg-gray-100 font-semibold',
  presetInactive:   'bg-white font-normal',
  customSection:    'border-t border-gray-100 p-3.5',
  customLabel:      'text-[11px] font-semibold text-gray-500 uppercase tracking-[0.06em] mb-2',
  customInputRow:   'flex gap-2 mb-2',
  dateInput:        'flex-1 py-1 px-1.5 border border-gray-200 rounded text-xs text-gray-700 outline-none min-w-0 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',
  applyBase:        'w-full py-1.5 border-none rounded text-xs font-medium transition-colors',
  applyEnabled:     'bg-blue-600 text-white cursor-pointer hover:bg-blue-700',
  applyDisabled:    'bg-gray-200 text-gray-400 cursor-default',

  // ── Info tooltip ────────────────────────────────────────────────────────────
  tooltipWrapper:   'relative inline-flex items-center align-middle',
  tooltipIcon:      'inline-flex items-center justify-center w-4 h-4 rounded-full bg-gray-200 text-gray-500 text-[11px] font-bold cursor-default leading-none shrink-0',
  tooltipPopup:     'absolute left-1/2 bottom-[calc(100%+8px)] -translate-x-1/2 bg-gray-800 text-gray-50 text-xs leading-relaxed p-3 rounded-lg w-80 z-[100] shadow-[0_4px_16px_rgba(0,0,0,0.2)] pointer-events-none font-normal',

  // ── Event selector dropdown ─────────────────────────────────────────────────
  eventDropdown:    'absolute top-[calc(100%+6px)] left-0 z-[200] bg-white border border-gray-200 rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] min-w-[220px] p-3',
  searchInput:      'w-full h-8 px-2.5 mb-2 border border-gray-200 rounded text-[13px] text-gray-700 outline-none box-border focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',
  optionsList:      'max-h-[220px] overflow-y-auto flex flex-col gap-0.5 -mr-2.5 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-gray-200 [&::-webkit-scrollbar-thumb]:rounded-full',
  optionClear:      'w-full text-left py-1.5 px-2 rounded text-[13px] text-gray-400 hover:bg-gray-50 border-none bg-transparent cursor-pointer',
  optionBase:       'w-full text-left py-1.5 px-2 rounded text-[13px] border-none cursor-pointer transition-colors',
  optionActive:     'bg-blue-50 text-blue-600 font-medium',
  optionInactive:   'bg-transparent text-gray-700 hover:bg-gray-50',
  optionEmpty:      'text-[13px] text-gray-400 py-1 px-2',

  // ── Period toggle (cohort) ──────────────────────────────────────────────────
  periodToggle:     'flex border border-gray-200 rounded-lg overflow-hidden',
  periodBtnBase:    'py-1.5 px-3.5 border-none text-[13px] cursor-pointer transition-colors',
  periodBtnDivider: 'border-r border-r-gray-200',
  periodBtnActive:  'bg-blue-600 text-white font-semibold',
  periodBtnIdle:    'bg-white text-gray-700 font-normal hover:bg-gray-50',

  // ── Empty / loading states ──────────────────────────────────────────────────
  stateText:        'p-5 text-gray-500',
  emptyCard:        'py-10 text-center text-gray-500',

  // ── Shared table ────────────────────────────────────────────────────────────
  tableScroll:      'overflow-x-auto',
  table:            'w-full border-collapse text-[13px]',

  // Header cells
  thStickyWide:     'text-left px-3 py-2 border-b-2 border-gray-200 text-gray-700 font-semibold sticky left-0 bg-white min-w-[200px]',
  thStickyNarrow:   'text-left px-3 py-2 border-b-2 border-gray-200 text-gray-700 font-semibold sticky left-0 bg-white min-w-[100px]',
  thWeek:           'px-2 py-2 border-b-2 border-gray-200 text-gray-500 font-medium text-center whitespace-nowrap min-w-[60px]',
  thUsers:          'px-2 py-2 border-b-2 border-gray-200 text-gray-500 font-medium text-center min-w-[60px]',
  thPeriod:         'px-2 py-2 border-b-2 border-gray-200 text-gray-500 font-medium text-center whitespace-nowrap min-w-[70px]',

  // Body cells
  tdStickyName:     'px-3 py-1.5 border-b border-gray-100 text-gray-700 font-medium sticky left-0 bg-white whitespace-nowrap',
  tdCount:          'px-2 py-1.5 border-b border-gray-100 text-center text-gray-700 font-medium',
  tdFuture:         'px-2 py-1.5 border-b border-gray-100 text-center text-gray-300',
  tdHeatmap:        'px-2 py-1.5 border-b border-gray-100 text-center font-medium rounded-sm',
  cohortSubtext:    'text-[10px] font-normal opacity-70',

  // ── Events list (DataTable) ─────────────────────────────────────────────────
  listCellName:     'py-3 px-4 text-gray-700',
  listCellBadge:    'py-3 px-4',
  listCellAction:   'py-3 px-4 text-right',
  chartBtn:         'inline-flex items-center justify-center p-1.5 rounded text-gray-500 hover:text-blue-600 hover:bg-blue-50 border-none bg-transparent cursor-pointer focus-visible:ring-2 focus-visible:ring-blue-500',
  chartBtnActive:   'text-blue-600 bg-blue-50',

  // ── Event drill-down ────────────────────────────────────────────────────────
  backLink:         'inline-flex items-center gap-1 text-sm text-gray-500 hover:text-blue-600 mb-2',
  detailHeader:     'flex justify-between items-end mb-4 gap-4',
  detailTitle:      'text-xl font-semibold text-gray-900 break-all',
  detailSubtitle:   'text-sm text-gray-500 mt-0.5',
  cellTime:         'py-3 px-4 text-gray-700 whitespace-nowrap align-top',
  cellUser:         'py-3 px-4 text-gray-700 whitespace-nowrap align-top',
  cellMeta:         'py-3 px-4 text-gray-700 align-top max-w-md whitespace-pre-wrap break-words',
  cellMetaShort:    'min-w-[7rem]',
  cellMetaLong:     'min-w-[18rem]',

};

export default Style;
